import { object, string } from 'yup'

export const schema = object().shape({
  email: string()
    .email('Email is not valid')
    .required('Please enter the required field'),
})
